import WaybillsTableColumnType from './index.vue'
export default WaybillsTableColumnType